<template>
    <div class="app">
        <!--面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>水果管理</el-breadcrumb-item>
            <el-breadcrumb-item>水果列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--卡片视图区域-->
        <el-card class="el-card">
            <el-row :gutter="20">
                <!--搜索与添加区域-->
                <el-col :span="6">
                    <el-input placeholder="请输入水果名称" v-model="queryInfo.inputName" clearable @clear="getFruitList">
                    </el-input>
                </el-col>
                <el-col :span="6">
                    <el-input placeholder="请输入水果品种" v-model="queryInfo.inputBreed" clearable @clear="getFruitList">
                    </el-input>
                </el-col>
                <!--搜索按钮-->
                <el-col :span="3">
                    <el-button type="primary" icon="el-icon-search" @click="getFruitList">{{$t('common.search')}}</el-button>
                </el-col>

                <el-col :span="2" style="float: right">
                    <el-button type="primary" icon="el-icon-plus" @click="openAddFruitInfo">{{$t('common.add')}}</el-button>
                </el-col>
            </el-row>
            <!--水果区域-->
            <el-table :data="fruitList.records" border stripe style="width: 100%" v-loading="loading">
                <el-table-column class="sectable" type="expand" width="50">
                    <template slot-scope="scope">
                        <!--公式区域-->
                        <el-table :data="scope.row.formulas" border stripe style="width: 100%">
                            <el-table-column label="#" type="index"></el-table-column>
                            <el-table-column prop="name" label="公式名称" align="center"></el-table-column>
                            <el-table-column prop="methodParams" label="公式参数" align="center"></el-table-column>
                            <el-table-column prop="identifyingCode" label="算法识别码" align="center"></el-table-column>
                            <el-table-column prop="descb" label="公式描述" align="center"></el-table-column>
                            <el-table-column prop="creationTime" label="创建时间" align="center"></el-table-column>
                        </el-table>
                    </template>
                </el-table-column>
                <el-table-column label="水果id" prop="fruitId" align="center" sortable></el-table-column>
<!--                <el-table-column label="水果品种id" prop="fruitVarietiesId" align="center"></el-table-column>-->
                <el-table-column label="水果名称" prop="name" align="center" sortable></el-table-column>
                <el-table-column label="水果品种名" prop="breed" align="center"></el-table-column>
                <el-table-column label="水果图片" prop="image" align="center">
                    <template slot-scope="scope">
                        <el-image
                                v-for="(item,index) in scope.row.image.split('|')"
                                :key="index"
                                style="width: 40px; height: 40px;margin-left: 10px"
                                :src="item"
                                fit="fill"></el-image>
                    </template>
                </el-table-column>
                <el-table-column label="水果介绍" prop="descb" align="center"></el-table-column>
                <el-table-column label="创建时间" prop="creationTime" align="center" sortable></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <!--修改-->
                        <el-tooltip effect="dark" content="修改" placement="top" :enterable="false">
                            <el-button type="primary" icon="el-icon-edit" size="mini"
                                       @click="showEditDialog(scope.row)"></el-button>
                        </el-tooltip>
                        <!--删除-->
                        <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
                            <el-button type="danger" icon="el-icon-delete" size="mini"
                                       @click="removeFruitById(scope.row)"></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页区域-->
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pageNum"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="queryInfo.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="fruitList.total">
            </el-pagination>
        </el-card>
        <!--修改水果的对话框-->
        <el-dialog
                title="修改水果"
                :visible.sync="editDialogVisible"
                width="900px">
            <!--内容主体区域-->
            <el-form :model="editFruitForm" ref="editOrderRef" label-width="100px" :inline="true">
                <el-form-item label="水果id" prop="fruitId">
                    <el-input v-model="editFruitForm.fruitId" style="width: 300px" disabled></el-input>
                </el-form-item>
                <!--<el-form-item label="水果品种id" prop="fruitVarietiesId" style="width: 400px">-->
                    <!--<el-input v-model="editFruitForm.fruitVarietiesId" style="width: 300px"></el-input>-->
                <!--</el-form-item>-->
<!--                <el-form-item label="水果品种id" prop="fruitVarietiesId" style="width: 400px">-->
<!--                    <el-input v-model="editFruitForm.fruitVarietiesId" style="width: 300px"></el-input>-->
<!--                </el-form-item>-->
                <el-form-item label="水果名称" prop="name" style="width: 400px">
                    <el-input v-model="editFruitForm.name" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="水果品种名" prop="breed">
                    <el-input v-model="editFruitForm.breed" style="width: 300px"></el-input>
                </el-form-item>
                <!--<el-form-item label="创建时间" prop="creationTime">-->
                    <!--<el-date-picker-->
                            <!--v-model="editFruitForm.creationTime"-->
                            <!--type="datetime"-->
                            <!--placeholder="选择日期时间" style="width: 300px">-->
                    <!--</el-date-picker>-->
                <!--</el-form-item>-->
                <el-form-item label="水果图片" prop="image" style="width: 800px">
                    <template>
                        <el-upload
                                ref="upload"
                                :action="baseUrl"
                                list-type="picture-card"
                                :file-list="fileList"
                                :on-success="handleUploadSuccess"
                                :before-upload="beforeImgUpload"
                                :headers="header"
                                :limit="1"
                                :on-exceed="handleExceed"
                        >
                            <i slot="default" class="el-icon-plus"></i>
                            <div slot="file" slot-scope="{file}">
                                <el-image
                                        class="el-upload-list__item-thumbnail"
                                        :src="file.url"
                                        fit="fill"
                                ></el-image>
                                <span class="el-upload-list__item-actions">
                                    <span
                                            v-if="!disabled"
                                            class="el-upload-list__item-delete"
                                            @click="handleRemove(file)"
                                    >
                                        <i class="el-icon-delete"></i>
                                    </span>
                                </span>
                            </div>
                        </el-upload>
                    </template>
                </el-form-item>
                <el-form-item label="水果介绍" prop="describe" style="width: 800px">
                    <el-input type="textarea" v-model="editFruitForm.descb" :rows="5" style="width: 700px"></el-input>
                </el-form-item>
                <el-form-item label="水果公式" prop="formulas" style="width: 800px">
                    <el-select v-model="chooseMethodList" placeholder="请选择公式" style="width: 700px">
                        <el-option
                                v-for="item in addMethodList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            {{item.name}}
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="边界值min" prop="min" style="width: 400px">
                    <el-input type="number" v-model="editFruitForm.min" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="边界值max" prop="max">
                    <el-input type="number" v-model="editFruitForm.max" style="width: 300px"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
    <el-button @click="editDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="editFruitInfo">确 定</el-button>
  </span>
        </el-dialog>
        <el-dialog
                title="增加水果"
                :visible.sync="addDialogVisible"
                width="900px">
            <el-form :model="addFruitForm" label-width="100px" :inline="true">
                <!--                <el-form-item label="水果id" prop="id" style="width: 400px">-->
                <!--                    <el-input v-model="addFruitForm.id" style="width: 300px"></el-input>-->
                <!--                </el-form-item>-->
<!--                <el-form-item label="水果id" prop="fruitId">-->
<!--                    <el-input v-model="addFruitForm.fruitId" style="width: 300px"></el-input>-->
<!--                </el-form-item>-->
                <!--<el-form-item label="水果品种id" prop="fruitVarietiesId" style="width: 400px">-->
                    <!--<el-input v-model="addFruitForm.fruitVarietiesId" style="width: 300px"></el-input>-->
                <!--</el-form-item>-->
                <el-form-item label="水果名称" prop="name" style="width: 400px">
                    <el-input v-model="addFruitForm.name" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="水果品种名" prop="breed">
                    <el-input v-model="addFruitForm.breed" style="width: 300px"></el-input>
                </el-form-item>
                <!--<el-form-item label="创建时间" prop="creationTime">-->
                    <!--<el-date-picker-->
                            <!--v-model="addFruitForm.creationTime"-->
                            <!--type="datetime"-->
                            <!--value-format="yyyy-MM-dd HH:mm:ss"-->
                            <!--placeholder="选择日期时间" style="width: 300px">-->
                    <!--</el-date-picker>-->
                <!--</el-form-item>-->
                <el-form-item label="水果图片" prop="image" style="width: 100%">
                    <template>
                        <el-upload
                                ref="upload"
                                :action="baseUrl"
                                list-type="picture-card"
                                :file-list="fileList"
                                :on-success="handleUploadSuccess"
                                :before-upload="beforeImgUpload"
                                :headers="header"
                                :limit="1"
                                :on-exceed="handleExceed"
                        >
                            <i slot="default" class="el-icon-plus"></i>
                            <div slot="file" slot-scope="{file}">
                                <el-image
                                        class="el-upload-list__item-thumbnail"
                                        :src="file.url"
                                ></el-image>
                                <span class="el-upload-list__item-actions">
                                    <span
                                            v-if="!disabled"
                                            class="el-upload-list__item-delete"
                                            @click="handleRemove(file)"
                                    >
                                        <i class="el-icon-delete"></i>
                                    </span>
                                </span>
                            </div>
                        </el-upload>
                    </template>
                </el-form-item>
                <el-form-item label="水果介绍" prop="describe" style="width: 100%">
                    <el-input type="textarea" v-model="addFruitForm.descb" :rows="5" style="width: 700px"></el-input>
                </el-form-item>
                <el-form-item label="水果公式" prop="formulas" style="width: 800px">
                    <el-select v-model="addFruitForm.chooseMethodList" placeholder="请选择公式" style="width: 700px">
                        <el-option
                                v-for="item in addMethodList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="边界值min" prop="min" style="width: 400px">
                    <el-input type="number" v-model="addFruitForm.min" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="边界值max" prop="max">
                    <el-input type="number" v-model="addFruitForm.max" style="width: 300px"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addFruitInfo">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "fruitList",
        data() {
            return {
                loading:false,
                fruitId: "",
                queryInfo: {
                    pageNum: 1,
                    pageSize: 10
                },
                baseUrl: "http://brix.zhengtusensor.com:8888/zhengtusensor/upload/fruit",
                addMethodList: {},
                chooseMethodList: "",
                fruitList: {
                    records: [],
                    total: 0
                },
                fileList: [],
                imgList: [],
                // 控制添加水果弹框的显示和隐藏
                addDialogVisible: false,
                // 控制修改水果对话框的显示与隐藏
                editDialogVisible: false,
                addMethodDialogVisible: false,
                addFruitForm: {
                },
                uploadFileList:"",
                // 修改的水果对象
                editFruitForm: {},
                // 添加水果的验证规则
                orderRules: {
                    subject: [
                        {required: true, message: '请输入水果标题', trigger: 'blur'},
                        {min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur'}
                    ],
                    state: [
                        {required: true, message: '请输入状态', trigger: 'blur'}
                    ]
                },
                dialogImageUrl: '',
                dialogVisible: false,
                disabled: false,
                header: {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            }
        },
        created() {
            this.getFruitList();
            this.getAllMethods();
        },
        methods: {
            handleUploadSuccess(response, file, fileList){
                this.fileList = fileList
            },
            beforeImgUpload(file){
                const isLt2M = file.size / 1024 / 1024 < 10;

                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 10MB!');
                }
                return isLt2M;
            },
            handleExceed(){
              this.$message.warning("只能上传一张图片")
            },
            // 获取水果列表
            async getFruitList() {
                this.loading = true
                let {data: res} = await this.$http.post(`/api/fruit/selectPage`, this.queryInfo);
                if (res.code !== 1) return this.$message.error(res.msg);
                this.fruitList.records = res.data.records;
                this.fruitList.total = res.data.total;
                this.loading = false
            },
            // 监听pageSize改变的事件
            handleSizeChange(newSize) {
                this.queryInfo.pageSize = newSize;
                this.getFruitList()
            },
            // 监听pageNum改变的事件
            handleCurrentChange(newPage) {
                this.queryInfo.pageNum = newPage;
                this.getFruitList()
            },
            // 展示修改水果的对话框
            async showEditDialog(fruit) {
                this.chooseMethodList = ""
                this.fileList = []
                const {data: res} = await this.$http.post(`/api/fruit/getById`, fruit);
                if (res.code !== 1) return this.$message.error("查询水果失败");
                this.editFruitForm = res.data;
                let images =  ""
                if(res.data != null && res.data.image != null){
                    images = res.data.image.split("|");
                }
                for(let i = 0;i<images.length;i++){
                    let file = {
                        name:"123.png",
                        url:images[i]
                    }
                    this.fileList.push(file)
                }
                let formulas = res.data.formulas;
                for(let i = 0;i<formulas.length;i++){
                    this.chooseMethodList = formulas[0].id;
                }
                this.editDialogVisible = true;
            },
            // 修改水果信息并提交
            async editFruitInfo() {
                this.editFruitForm.chooseMethodList = this.chooseMethodList;
                let ip = "http://brix.zhengtusensor.com:8888";
                let param = "";
                for(let i = 0;i<this.fileList.length;i++){
                    if(this.fileList[i].response){
                        if(i == 0){
                            param += ip + this.fileList[i].response.data
                        }else{
                            param += "|" + ip + this.fileList[i].response.data;
                        }
                    }else{
                        if(i == 0){
                            param += this.fileList[i].url
                        }else{
                            param += "|" + this.fileList[i].url;
                        }
                    }
                }
                this.editFruitForm.images = param;
                const {data: res} = await this.$http.post(`/api/fruit/updateFruitAndMethod`, this.editFruitForm);
                if (res.code !== 1) return this.$message.error(res.msg);
                this.$message.success("修改水果成功");
                // 隐藏添加水果对话框
                this.editDialogVisible = false;
                // 重新获取水果列表
                this.getFruitList();
            },
            // 根据id删除水果信息
            async removeFruitById(fruit) {
                // 弹框询问用户是否删除水果
                await this.$confirm('此操作将永久删除该水果, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    // 删除水果
                    const {data: res} = await this.$http.post(`/api/fruit/removeById`, fruit);
                    if (res.code !== 1) return this.$message.error("删除失败");
                    this.$message.success("删除成功");
                    // 重新获取水果列表
                    this.getFruitList();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleRemove(file) {
                let index = this.fileList.indexOf(file);
                if (index > -1) {
                    this.fileList.splice(index, 1);
                }
            },
            /**
             * 新增水果
             */
            async addFruitInfo() {
                let param = "";
                if (this.addFruitForm.name == "" || this.addFruitForm.name == undefined) {
                    this.$message.error("请输入水果名")
                    return
                }
                if (this.addFruitForm.breed == "" || this.addFruitForm.breed == undefined) {
                    this.$message.error("请输入水果品种")
                    return
                }
                let ip = "http://brix.zhengtusensor.com:8888";
                for(let i = 0;i<this.fileList.length;i++){
                    if(i == 0){
                        param += ip + this.fileList[i].response.data
                    }else{
                        param += "|" + ip + this.fileList[i].response.data;
                    }
                }
                this.addFruitForm.images = param
                let params = this.addFruitForm;
                const {data: res} = await this.$http.post(`/api/fruit/addFruitAndMethods`, params);
                if (res.code !== 1) {
                    return this.$message.error("增加失败");
                } else {
                    this.addDialogVisible = false;
                    this.getFruitList();
                    return this.$message.success("增加成功");
                }

            },
            /**
             * 打开新增水果的弹框
             */
            openAddFruitInfo() {
                this.fileList = []
                this.addFruitForm = {}
                this.addDialogVisible = true
            },
            async getAllMethods() {
                const {data: res} = await this.$http.post(`/api/formula/selectList`, {});
                if (res.code !== 1) return this.$message.error("查询水果失败");
                this.addMethodList = res.data;
            }
        }
    }
</script>

<style lang="less" scoped>
    .el-table {
        margin-top: 15px;
        font-size: 12px;
    }

    .el-pagination {
        margin-top: 15px;
    }

    .app .el-card {
        width: 99%;
    }
</style>
